module.exports = __webpack_public_path__ + "static/media/picsart.f89fb5fa.svg";